const enum MissionStatus {
    None = 0,
    Todo = 1,
    Waiting = 2,
    Processing = 3,
    Done = 4,
}

export default MissionStatus;